import React from "react";
import Icon from "@ant-design/icons";

const SharedFileSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <path
            d="M4 2.40039V12.8004H8H12V9.00039V5.20039V2.40039H4Z"
            fill="#165ABF"
            stroke="#165ABF"
            strokeLinejoin="round"
        />
        <path
            d="M5.59961 6H10.3996"
            stroke="#F9FBFE"
            strokeLinecap="round"
        />
        <path
            d="M5.59961 8.40039H8.79961"
            stroke="#F9FBFE"
            strokeLinecap="round"
        />
    </svg>
);

const SharedFileIcon = (props) => {
    return <Icon component={SharedFileSvg} {...props} />;
};

export { SharedFileIcon };